export default (value,
    result) => {
    if (_.isInteger(value) || (_.isString(value) && value !== '')) return value;
    return _.isEmpty(value) ? result : value;
}
